import React from "react";
import BasePage from "../base/BasePage";
import NavBar1 from "../components/Navbar1";
import SolutionsPresenter from "./SolutionsPresenter";
import HeroSolutionSection from "./components/HeroSolutionSection";
import FlagshipProductsSection from "./components/FlagshipProductsSection";
import FooterSection from "./components/FooterSection";
import CallToActionSection from "./components/CallToActionSection";

import "./SolutionsPage.css";

class SolutionsPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new SolutionsPresenter();
  }

    navigateTo(path, argument, options) {
        const navigate = this.props.navigate;
        if (navigate) {
            navigate(path, {state: argument, ...options});
        } else {
            const params = new URLSearchParams(argument).toString();
            if (window.location.pathname !== path) {
                document.location.href = `${path}`;
            }
        }
    }

  render() {
    const heroContent = this.presenter.getHeroSectionContent();
    const products = this.presenter.getFlagshipProducts();

    return (
      <>
        <NavBar1 className="shadow-sm" />

        <HeroSolutionSection heroContent={heroContent} />

        <FlagshipProductsSection
          products={products}
          navigateTo={(path) => this.navigateTo(path)}
        />

        <CallToActionSection />

        <FooterSection footerText={this.presenter.getFooterContent().text} />
      </>
    );
  }
}

export default SolutionsPage;
